import { useAtom } from 'jotai'
import { useEntityFiltersBar } from '@sequencehq/core-components'
import {
  watchtowerFiltersAtom,
  WatchtowerFilterType
} from 'Automations/watchtower/atoms'
import { WATCHTOWER_FILTER_CONFIGS } from 'Automations/watchtower/watchtowerFilterConfigs'
import { WatchtowerFilterButton } from 'Automations/components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

export const ExecutionAddFilter = () => {
  const flags = useFeatureFlags()
  const filters = WATCHTOWER_FILTER_CONFIGS({
    useAutomationsDunning: flags.useAutomationsDunning
  })
  const [selectedFilters, setSelectedFilters] = useAtom(watchtowerFiltersAtom)
  const {
    selectedFilters: hookFilters,
    hasActiveFilters,
    updateFilter
  } = useEntityFiltersBar<WatchtowerFilterType>({
    filters,
    selectedFilters,
    onFilterChange: setSelectedFilters
  })

  return (
    <WatchtowerFilterButton
      filterConfigs={filters}
      selectedFilters={hookFilters}
      hasActiveFilters={hasActiveFilters}
      onFilterChange={updateFilter}
    />
  )
}
